import { countries_options } from "@/components/Form/CountryPhone/data";
import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { z } from "zod";
import { useTranslation } from "react-i18next";

const filterC5IssuersSchema = z.object({
  name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  country_contains: z.string().optional(),
  sector_contains: z.string().optional(),
});
const filterC5IssuersFields = filterC5IssuersSchema.keyof().enum;

export type FilterC5IssuersSchema = z.infer<typeof filterC5IssuersSchema>;

export function FilterC5Issuers() {
  const { t, i18n } = useTranslation(["common", "tables"]);
  const language = i18n.language?.startsWith("en") ? "en" : "fr";

  const fields: Field[] = [
    {
      name: filterC5IssuersFields.name_contains,
      label: t(`${Tables.C5_ISSUERS}.columns.name`, {
        ns: "tables",
        defaultValue: "Name",
      }),
      type: "asyncAutocomplete",
      base_url: `${Clients.C5}/${Tables.C5_ISSUERS}`,
      column_name: "name",
    },
    {
      name: filterC5IssuersFields.country_contains,
      label: t(`${Tables.C5_ISSUERS}.columns.country_name`, {
        ns: "tables",
        defaultValue: "Country",
      }),
      type: "autocomplete",
      options: countries_options,
    },
    {
      name: filterC5IssuersFields.sector_contains,
      label: t(`${Tables.C5_ISSUERS}.columns.sector`, {
        ns: "tables",
        defaultValue: "Sector",
      }),
      type: "select",
      useTranslation: true,
      client: Clients.C5,
      table_name: Tables.C5_ISSUERS,
      language,
      translate_key: "sector",
    },
  ];

  return (
    <FilterTable
      client={Clients.C5}
      schema={filterC5IssuersSchema}
      tableName={Tables.C5_ISSUERS}
      fields={fields}
    />
  );
}
